import { IMutedMediaState } from './types';

export const NEW_MESSAGE_FORM_NAME = 'new-message-form';
export const SEARCH_FORM_NAME = 'chat-search-form';

export const CALL_ERRORS = {
  USER_PRIVACY_RESTRICTED: 'USER_PRIVACY_RESTRICTED',
  USER_IS_BLOCKED: 'USER_IS_BLOCKED',
  INPUT_USER_DEACTIVATED: 'INPUT_USER_DEACTIVATED',
  PARTICIPANT_VERSION_OUTDATED: 'PARTICIPANT_VERSION_OUTDATED',
  USER_ID_INVALID: 'USER_ID_INVALID',
  CALL_PROTOCOL_FLAGS_INVALID: 'CALL_PROTOCOL_FLAGS_INVALID',
};

export const DEFAULT_MUTE_VALUE: IMutedMediaState = {
  video: { me: false, them: false },
  audio: { me: false, them: false },
};
